<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a href="/sirang/cookies">Cookies</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-1" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="portlet-column portlet-column-only" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-only" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-static portlet-static-end portlet-journal-content " id="p_p_id_56_INSTANCE_D9HFQm6d3gjn_">
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_D9HFQm6d3gjn">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">

                                    <table style="width: 100%;">
                                       <tbody>
                                          <tr>
                                             
                                             <td>
                                                <header class="portlet-topper gradient">
                                                   <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Informazioni sui cookies</span> </h1>
                                                </header>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
         
                                    <div class="journal-content-article">
                                       <p>
                                          <font style="">I siti web della Regione Autonoma della Sardegna utilizzano cookie tecnici per garantire il corretto funzionamento delle procedure e migliorare l'esperienza di uso delle applicazioni online. Il presente testo fornisce informazioni sull'uso dei cookie e di tecnologie similari, su come sono utilizzati dal sito e su come gestirli.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <b>Definizioni</b>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">I cookie sono piccoli frammenti di testo (lettere e/o numeri) che i server web dei siti visitati trasmettono ai terminali degli utenti quando visitano tali siti, con la richiesta di essere memorizzati su tali terminali per essere poi letti dai server web alle visite successive. I cookie delle c.d. "terze parti" vengono, invece, impostati da un sito web diverso da quello che l'utente sta visitando. Questo perché su ogni sito possono essere presenti elementi (immagini, mappe, suoni, specifici link a pagine web di altri domini, ecc.) che risiedono su server diversi da quello del sito visitato. Come previsto dalla normativa, al fine di impostare alcune tipologie di cookie di seguito dettagliate, viene richiesto il consenso all'utente tramite un'informativa disponibile nel sito. Tale consenso è applicato sul sito corrente.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <font style="">
                                                <b>Tipologie di cookie</b>
                                             </font>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">In base alle caratteristiche e all'utilizzo dei cookie si possono distinguere diverse categorie.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <b>Cookie tecnici</b>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">Sono i cookie che servono ad effettuare la navigazione o a fornire un servizio richiesto dall'utente. Non vengono utilizzati per scopi ulteriori e sono normalmente installati direttamente dal titolare del sito web. Senza il ricorso a tali cookie, che consentono di effettuare e mantenere l'identificazione dell'utente nell'ambito della sessione, alcune operazioni non potrebbero essere più completate e/o risultare meno sicure o non potrebbero essere compiute del tutto.</font>
                                       </p>
                                       <p>
                                          <font style="">I cookie tecnici possono essere suddivisi in:</font>
                                       </p>
                                       <ul>
                                          <li>
                                             <p align="justify">
                                                <font style="">cookie di navigazione o di sessione che garantiscono la normale navigazione e fruizione del sito web;</font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">cookie analytics, assimilati ai cookie tecnici laddove utilizzati direttamente dal gestore del sito per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso;</font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">cookie di funzionalità che permettono all'utente la navigazione in funzione di una serie di criteri selezionati al fine di migliorare il servizio reso allo stesso.</font>
                                             </p>
                                          </li>
                                       </ul>
                                       <p align="justify"> &nbsp;</p>
                                       <p>
                                          <font style="">Per l'installazione di tali cookie non è richiesto il preventivo consenso degli utenti, mentre resta fermo l'obbligo di dare la presente informativa.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <b>Cookie di profilazione</b>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">Sono volti a creare profili relativi all'utente e vengono utilizzati al fine di inviare messaggi pubblicitari in linea con le preferenze manifestate dallo stesso nell'ambito della navigazione in rete. Tale tipologia di cookie non è presente nei siti della Regione Autonoma della Sardegna.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <font style="">
                                                <b>Cookie di "terze parti"</b>
                                             </font>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">Visitando il presente sito web si potrebbero ricevere cookie da siti gestiti da altre organizzazioni ("terze parti").</font>
                                       </p>
                                       <p>
                                          <font style="">Un esempio è rappresentato dalla presenza dei "social plugin" per Facebook, Twitter, Google+ o LinkedIn, oppure sistemi di visualizzazione di contenuti multimediali embedded (integrati) come ad esempio Youtube e Flickr.</font>
                                       </p>
                                       <p>
                                          <font style="">Si tratta di parti generate direttamente dai suddetti siti ed integrati nella pagina web del sito ospitante visitato. La presenza di questi plugin comporta la trasmissione di cookie da e verso tutti i siti gestiti da terze parti.</font>
                                       </p>
                                       <p>
                                          <font style="">La gestione delle informazioni raccolte da "terze parti" è disciplinata dalle relative informative cui si prega di fare riferimento.</font>
                                       </p>
                                       <p>
                                          <font style="">Per garantire una maggiore trasparenza e comodità, si riportano di seguito gli indirizzi web delle diverse informative e delle modalità per la gestione dei cookie:</font>
                                       </p>
                                       <ul>
                                          <li>
                                             <p align="justify">
                                                <font style="">Facebook informativa: <font color="#0000ff">
                                                      <u>
                                                         <a href="https://www.facebook.com/help/cookies/" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">https://www.facebook.com/help/cookies/</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Facebook (configurazione): accedere al proprio account. Sezione privacy</font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Twitter informative: <font color="#0000ff">
                                                      <u>
                                                         <a href="https://support.twitter.com/articles/20170514" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">https://support.twitter.com/articles/20170514</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Twitter (configurazione): <font color="#0000ff">
                                                      <u>
                                                         <a href="https://twitter.com/settings/security" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">https://twitter.com/settings/security</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Youtube/Google+ informativa: <font color="#0000ff">
                                                      <u>
                                                         <a href="http://www.google.it/intl/it/policies/technologies/cookies/" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">http://www.google.it/intl/it/policies/technologies/cookies/</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Youtube/Google+ (configurazione): <font color="#0000ff">
                                                      <u>
                                                         <a href="http://www.google.it/intl/it/policies/technologies/managing/" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">http://www.google.it/intl/it/policies/technologies/managing/</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Flickr/Yahoo informativa <font color="#0000ff">
                                                      <u>
                                                         <a href="https://policies.yahoo.com/ie/it/yahoo/privacy/topics/cookies/index.htm" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">https://policies.yahoo.com/ie/it/yahoo/privacy/topics/cookies/index.htm</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">Flickr/Yahoo (configurazione): <font color="#0000ff">
                                                      <u>
                                                         <a href="https://policies.yahoo.com/ie/it/yahoo/privacy/tools/index.htm" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">https://policies.yahoo.com/ie/it/yahoo/privacy/tools/index.htm</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                          <li>
                                             <p align="justify">
                                                <font style="">
                                                   <span lang="en-US">Open Street Map informativa: </span>
                                                   <font color="#0000ff">
                                                      <u>
                                                         <a href="http://wiki.openstreetmap.org/wiki/Privacy_Policy" style="color: rgb(0, 0, 255);" target="_blank">
                                                            <span lang="en-US">http://wiki.openstreetmap.org/wiki/Privacy_Policy</span>
                                                         </a>
                                                      </u>
                                                   </font>
                                                </font>
                                             </p>
                                          </li>
                                       </ul>
                                       <p class="western"> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <b>Google Analytics</b>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">Il sito include anche componenti trasmesse da Google Analytics, un servizio di analisi del traffico web fornito da Google, Inc. ("Google"). Tali cookie sono usati al solo fine di monitorare e migliorare le prestazioni del sito.</font>
                                       </p>
                                       <p>
                                          <font style="">Per ulteriori informazioni si rinvia alla pagina: <font color="#0000ff">
                                                <u>
                                                   <a href="https://www.google.it/policies/privacy/partners/%20" style="color: rgb(0, 0, 255);" target="_blank">
                                                      <span lang="en-US">https://www.google.it/policies/privacy/partners/</span>
                                                   </a>
                                                </u>
                                             </font>
                                          </font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <b>Durata dei cookie</b>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">Alcuni cookie (cookie di sessione) restano attivi solo fino alla chiusura del browser o all'esecuzione dell'eventuale comando di logout. Altri cookie "sopravvivono" alla chiusura del browser e sono disponibili anche in successive visite dell'utente. Questi cookie sono detti persistenti e la loro durata è fissata dal server al momento della loro creazione. In alcuni casi è fissata una scadenza, in altri casi la durata è illimitata.</font>
                                       </p>
                                       <p> &nbsp;</p>
                                       <p>
                                          <font style="">
                                             <font style="">
                                                <b>Gestione dei cookie</b>
                                             </font>
                                          </font>
                                       </p>
                                       <p>
                                          <font style="">L'utente può decidere se accettare o meno i cookie utilizzando le impostazioni del proprio browser.<br> Si precisa che la disabilitazione totale o parziale dei cookie tecnici potrebbe compromettere l'utilizzo ottimale del sito. La disabilitazione dei cookie "terze parti" non pregiudica in alcun modo la navigabilità.<br> L'impostazione può essere definita in modo specifico per i diversi siti e applicazioni web. Inoltre i browser consentono di definire impostazioni diverse per i cookie "proprietari" e per quelli di "terze parti". A titolo di esempio, in Firefox attraverso il menu "Strumenti&gt;Opzioni&gt;Privacy" è possibile accedere ad un pannello di controllo dove è possibile definire se accettare o meno i diversi tipi di cookie e procedere alla loro rimozione.</font>
                                             </p>
                                             <p> &nbsp;</p>
                                             <p>
                                                <font style="">In internet è facilmente reperibile la documentazione su come impostare le regole di gestione dei cookie per il proprio browser, a titolo di esempio si riportano alcuni indirizzi relativi ai principali browser:</font>
                                             </p>
                                             <ul>
                                                <li>
                                                   <p align="justify">
                                                      <font style="">
                                                         <span lang="en-US">Chrome: </span>
                                                         <font color="#0000ff">
                                                            <u>
                                                               <a href="https://support.google.com/chrome/answer/95647?hl=it" style="color: rgb(0, 0, 255);" target="_blank">
                                                                  <span lang="en-US">https://support.google.com/chrome/answer/95647?hl=it</span>
                                                               </a>
                                                            </u>
                                                         </font>
                                                      </font>
                                                   </p>
                                                </li>
                                                <li>
                                                   <p align="justify">
                                                      <font style="">
                                                         <span lang="en-US">Firefox: </span>
                                                         <font color="#0000ff">
                                                            <u>
                                                               <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" style="color: rgb(0, 0, 255);" target="_blank">
                                                                  <span lang="en-US">https://support.mozilla.org/it/kb/Gestione%20dei%20cookie</span>
                                                               </a>
                                                            </u>
                                                         </font>
                                                      </font>
                                                   </p>
                                                </li>
                                                <li>
                                                   <p align="justify">
                                                      <font style="">
                                                         <span lang="en-US">Internet Explorer: </span>
                                                         <font color="#0000ff">
                                                            <u>
                                                               <a href="https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies" style="color: rgb(0, 0, 255);">
                                                                  <span lang="en-US">https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies</span>
                                                               </a>
                                                            </u>
                                                         </font>
                                                      </font>
                                                   </p>
                                                </li>
                                                <li>
                                                   <p align="justify">
                                                      <font style="">Apple Safari: <font color="#0000ff">
                                                            <u>
                                                               <a href="http://support.apple.com/kb/HT1677?viewlocale=it_IT" style="color: rgb(0, 0, 255);" target="_blank">http://support.apple.com/kb/HT1677?viewlocale=it_IT</a>
                                                            </u>
                                                         </font>
                                                      </font>
                                                   </p>
                                                </li>
                                                <li>
                                                   <p align="justify">
                                                      <font style="">Opera: <font color="#0000ff">
                                                            <u>
                                                               <a href="http://help.opera.com/Windows/10.00/it/cookies.html" style="color: rgb(0, 0, 255);" target="_blank">http://help.opera.com/Windows/10.00/it/cookies.html</a>
                                                            </u>
                                                         </font>
                                                      </font>
                                                   </p>
                                                </li>
                                             </ul>
                                          </div>                                       
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>